package com.karawek.core.auth.presenter

import com.karawek.core.auth.screen.OtpVerificationScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(OtpVerificationPresenter::class)
public class OtpVerificationPresenterFactory(
  private val factory:
      (screen: OtpVerificationScreen, navigator: Navigator) -> OtpVerificationPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is OtpVerificationScreen -> factory(screen, navigator)
    else -> null
  }
}
